import Vue from 'vue'

/**
 * Password Check Computed Fields
 */
export default Vue.extend({
  data: () => ({
    password: '',
  }),

  computed: {
    /** Check if password has upper case letters */
    isPasswordHasCapital(): boolean {
      const upperCaseLetters = /[A-Z]/g
      return upperCaseLetters.test(this.password)
    },

    /** Check if password has lower case letters */
    isPasswordHasRegular(): boolean {
      const lowerCaseLetters = /[a-z]/g
      return lowerCaseLetters.test(this.password)
    },

    /** Check if password has any cyrillic letters */
    isPasswordHasCyrillic(): boolean {
      const cyrillic = /[а-яА-Я]/g
      return cyrillic.test(this.password)
    },

    /** Check if password has numbers */
    isPasswordHasNumbers(): boolean {
      const digits = /[0-9]/g
      return digits.test(this.password)
    },
  },
})
